export interface AnimeItem {
  id: string;
  title: string;
  subtitle: string;
  category: string;
  categorySlug: string;
  description: string;
  longDescription: string;
  coverImage: string;
  bannerImage: string;
  rating: number;
  episodes: number;
  status: string;
  year: number;
  studio: string;
  director: string;
  tags: string[];
  views: number;
  updateDate: string;
  featured: boolean;
}

export interface AnimeCategory {
  name: string;
  slug: string;
  description: string;
  iconClass: string;
  count: number;
}

export const animeCategories: AnimeCategory[] = [
  {
    name: '热血战斗',
    slug: 'action',
    description: '燃爆你的每一个细胞，感受最纯粹的热血与激情',
    iconClass: 'ri-fire-line',
    count: 6,
  },
  {
    name: '奇幻冒险',
    slug: 'fantasy',
    description: '踏入异世界的大门，开启不可思议的冒险之旅',
    iconClass: 'ri-magic-line',
    count: 5,
  },
  {
    name: '恋爱日常',
    slug: 'romance',
    description: '青春的心跳，甜蜜的邂逅，浪漫的校园物语',
    iconClass: 'ri-heart-line',
    count: 4,
  },
  {
    name: '搞笑喜剧',
    slug: 'comedy',
    description: '笑到停不下来，治愈你所有的不开心',
    iconClass: 'ri-emotion-laugh-line',
    count: 4,
  },
  {
    name: '悬疑推理',
    slug: 'mystery',
    description: '抽丝剥茧，层层深入，揭开不为人知的真相',
    iconClass: 'ri-search-eye-line',
    count: 3,
  },
  {
    name: '科幻未来',
    slug: 'scifi',
    description: '超越时代的想象，探索科技的无限可能',
    iconClass: 'ri-rocket-line',
    count: 3,
  },
];

export const animeList: AnimeItem[] = [
  {
    id: 'anime-001',
    title: '星辰之刃',
    subtitle: 'Star Blade',
    category: '热血战斗',
    categorySlug: 'action',
    description: '在星辰陨落的世界中，少年剑士踏上寻找传说之刃的旅程。',
    longDescription: '在遥远的未来，人类文明已经扩展到银河系的每个角落。然而，一场被称为"星辰陨落"的灾难性事件摧毁了大部分人类殖民地，神秘的异星生物开始入侵。少年剑士凌风，作为最后一位"星辰剑士"的传人，必须找到传说中的星辰之刃，才能拯救人类最后的希望。他踏上了一段充满危险与挑战的旅程，在这趟旅途中，他结识了来自不同星球的伙伴，也逐渐揭开了星辰陨落背后的惊天秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20swordsman%20holding%20a%20glowing%20blade%20in%20a%20star-filled%20galaxy%20background%2C%20dynamic%20action%20pose%2C%20vibrant%20warm%20colors%20with%20golden%20and%20crimson%20tones%2C%20clean%20anime%20art%20style%20with%20soft%20gradients%2C%20cinematic%20lighting%2C%20minimal%20background%20with%20stars%20and%20nebula&width=600&height=850&seq=sakura-anime-cover-001&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20anime%20scene%20with%20a%20swordsman%20silhouette%20against%20a%20cosmic%20galaxy%20backdrop%2C%20golden%20energy%20sword%20glowing%2C%20dramatic%20cinematic%20lighting%2C%20warm%20color%20palette%20with%20deep%20space%20blues%20and%20fiery%20oranges%2C%20anime%20cinematic%20style%2C%20epic%20composition&width=1600&height=600&seq=sakura-anime-banner-001&orientation=landscape',
    rating: 9.5,
    episodes: 24,
    status: '连载中',
    year: 2025,
    studio: '星辰动画社',
    director: '王明辉',
    tags: ['战斗', '科幻', '冒险', '热血'],
    views: 1250000,
    updateDate: '2026-08-02',
    featured: true,
  },
  {
    id: 'anime-002',
    title: '梦境花园',
    subtitle: 'Dream Garden',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    description: '少女意外闯入梦境世界，与奇幻生物一起守护心灵花园。',
    longDescription: '普通高中生林晓梦在一次意外中获得了进入"梦境花园"的能力。这是一个由人类潜意识构建的奇幻世界，充满了不可思议的生物和景象。然而，一股黑暗力量正在侵蚀这个美丽的花园，试图通过梦境控制人类的意识。林晓梦必须与梦境中的守护精灵们联手，穿越层层梦境，找到黑暗的源头，保护现实世界免于崩溃。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20girl%20in%20a%20magical%20garden%20filled%20with%20glowing%20flowers%20and%20floating%20crystals%2C%20ethereal%20soft%20lighting%2C%20pastel%20pink%20and%20mint%20green%20color%20scheme%2C%20clean%20anime%20art%20style%2C%20dreamy%20atmosphere%2C%20whimsical%20fantasy%20elements&width=600&height=850&seq=sakura-anime-cover-002&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dreamy%20fantasy%20anime%20landscape%20with%20floating%20islands%20and%20glowing%20flora%2C%20soft%20ethereal%20lighting%2C%20pastel%20color%20palette%2C%20magical%20atmosphere%2C%20anime%20cinematic%20style%2C%20wide%20composition%20with%20a%20distant%20castle%20silhouette&width=1600&height=600&seq=sakura-anime-banner-002&orientation=landscape',
    rating: 9.2,
    episodes: 12,
    status: '已完结',
    year: 2024,
    studio: '梦幻工坊',
    director: '陈思雨',
    tags: ['奇幻', '冒险', '治愈', '少女'],
    views: 890000,
    updateDate: '2025-06-15',
    featured: true,
  },
  {
    id: 'anime-003',
    title: '樱花下的约定',
    subtitle: 'Promise Under Sakura',
    category: '恋爱日常',
    categorySlug: 'romance',
    description: '樱花树下的邂逅，青春校园里最纯粹的恋爱故事。',
    longDescription: '转校生苏樱在樱花盛开的季节来到青叶高中，在樱花树下遇到了温柔内向的少年林澈。两人因为一本绘本而结缘，在校园的日常相处中，彼此的感情悄然滋长。然而，苏樱隐藏着一个不能说的秘密——她将在樱花凋零的季节离开这座城市。在这个限定的春天里，两个人该如何面对这份即将分离的感情？一段关于青春、约定与告别的校园恋爱物语。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20boy%20and%20girl%20standing%20under%20a%20cherry%20blossom%20tree%20in%20spring%2C%20soft%20pink%20petals%20falling%2C%20warm%20sunlight%20filtering%20through%20branches%2C%20romantic%20atmosphere%2C%20clean%20anime%20art%20style%2C%20gentle%20color%20palette&width=600&height=850&seq=sakura-anime-cover-003&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20spring%20scene%20with%20a%20path%20lined%20with%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20petals%20drifting%20in%20the%20wind%2C%20warm%20golden%20sunlight%2C%20school%20building%20in%20the%20distance%2C%20romantic%20cinematic%20composition%2C%20soft%20pink%20and%20cream%20palette&width=1600&height=600&seq=sakura-anime-banner-003&orientation=landscape',
    rating: 9.0,
    episodes: 13,
    status: '已完结',
    year: 2024,
    studio: '青叶映像',
    director: '林小雨',
    tags: ['恋爱', '校园', '青春', '治愈'],
    views: 720000,
    updateDate: '2025-04-01',
    featured: true,
  },
  {
    id: 'anime-004',
    title: '恶魔高校日常',
    subtitle: 'Demon High Daily',
    category: '搞笑喜剧',
    categorySlug: 'comedy',
    description: '在全是恶魔的高中里当唯一一个人类的爆笑日常。',
    longDescription: '普通高中生张小凡在开学第一天发现自己被分配到了一个全是恶魔的班级！同学们有吸血鬼、狼人、幽灵、魔女……而他是唯一的人类。在这个奇葩的班级里，每天都有意想不到的爆笑事件发生。从魔女实验失败把教室炸飞，到狼人学长在月圆之夜追着自己的尾巴跑，再到吸血鬼班长因为晕血而不得不喝番茄汁……这里没有严肃的日常，只有让人笑到肚子痛的校园喜剧。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20normal%20high%20school%20boy%20surrounded%20by%20comical%20monster%20classmates%20like%20vampire%20girl%20and%20werewolf%20boy%2C%20colorful%20and%20playful%20style%2C%20bright%20classroom%20setting%2C%20funny%20expressions%2C%20clean%20anime%20comedy%20art%20style&width=600&height=850&seq=sakura-anime-cover-004&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Colorful%20and%20chaotic%20anime%20classroom%20scene%20with%20various%20monster%20students%20doing%20silly%20things%2C%20bright%20vibrant%20colors%2C%20comedy%20anime%20style%2C%20energetic%20composition%2C%20fun%20atmosphere%2C%20school%20setting&width=1600&height=600&seq=sakura-anime-banner-004&orientation=landscape',
    rating: 8.8,
    episodes: 12,
    status: '连载中',
    year: 2025,
    studio: '爆笑工房',
    director: '赵大龙',
    tags: ['搞笑', '校园', '日常', '奇幻'],
    views: 980000,
    updateDate: '2026-07-28',
    featured: false,
  },
  {
    id: 'anime-005',
    title: '暗影追踪者',
    subtitle: 'Shadow Chaser',
    category: '悬疑推理',
    categorySlug: 'mystery',
    description: '天才侦探与神秘组织的对决，每一起案件都暗藏玄机。',
    longDescription: '天才少年侦探江寒拥有超乎常人的观察力和推理能力。当他接手调查一系列看似无关的离奇案件时，发现所有线索都指向一个神秘组织——"暗影会"。每一起案件背后都隐藏着更大的阴谋，每一个线索都可能是致命的陷阱。江寒必须在有限的时间内查明真相，否则下一个受害者可能就是他自己。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20dimly%20lit%20alley%2C%20mysterious%20atmosphere%2C%20dramatic%20shadows%2C%20noir%20inspired%20anime%20art%2C%20warm%20amber%20streetlight%2C%20clean%20composition&width=600&height=850&seq=sakura-anime-cover-005&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20cityscape%20at%20night%20with%20rain-slicked%20streets%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20silhouette%20of%20a%20detective%20figure%2C%20noir%20atmosphere%2C%20warm%20yellow%20and%20deep%20amber%20tones%2C%20cinematic%20anime%20style&width=1600&height=600&seq=sakura-anime-banner-005&orientation=landscape',
    rating: 9.3,
    episodes: 24,
    status: '已完结',
    year: 2024,
    studio: '暗夜映像',
    director: '刘墨白',
    tags: ['悬疑', '推理', '侦探', '犯罪'],
    views: 1100000,
    updateDate: '2025-03-20',
    featured: true,
  },
  {
    id: 'anime-006',
    title: '机械纪元',
    subtitle: 'Machine Era',
    category: '科幻未来',
    categorySlug: 'scifi',
    description: '人类与AI共存的世界，探索意识与灵魂的边界。',
    longDescription: '公元2157年，人工智能已经深度融入人类社会。仿生人拥有人类的外表和情感，但他们是否拥有真正的"灵魂"？人类工程师程宇被派往调查一起仿生人异常事件，却意外发现了一个足以颠覆整个社会秩序的真相。在这场关于意识、灵魂与人性的探索中，程宇必须重新定义什么是"活着"。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20futuristic%20android%20girl%20with%20glowing%20circuit%20patterns%2C%20cyberpunk%20city%20background%2C%20sleek%20sci-fi%20design%2C%20warm%20neon%20lights%2C%20clean%20anime%20art%20style%2C%20technological%20aesthetic&width=600&height=850&seq=sakura-anime-cover-006&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Futuristic%20anime%20cityscape%20with%20towering%20skyscrapers%20and%20holographic%20displays%2C%20flying%20vehicles%2C%20warm%20sunset%20lighting%2C%20cyberpunk%20meets%20utopian%20aesthetic%2C%20clean%20sci-fi%20anime%20style%2C%20cinematic%20wide%20shot&width=1600&height=600&seq=sakura-anime-banner-006&orientation=landscape',
    rating: 9.1,
    episodes: 12,
    status: '连载中',
    year: 2026,
    studio: '未来之眼',
    director: '张宇恒',
    tags: ['科幻', 'AI', '未来', '哲学'],
    views: 650000,
    updateDate: '2026-08-01',
    featured: false,
  },
  {
    id: 'anime-007',
    title: '龙之传说',
    subtitle: 'Legend of Dragons',
    category: '热血战斗',
    categorySlug: 'action',
    description: '少年龙骑士的成长史诗，驾驭远古巨龙守护世界和平。',
    longDescription: '在龙与人类共存的世界中，龙骑士是最高荣誉的象征。少年白夜出身平凡，却意外与传说中最强大的远古巨龙签订了契约。从此，他成为了众矢之的——有人想利用他的力量，有人想夺走他的巨龙，也有人将他视为世界的威胁。白夜必须在战斗与考验中成长，证明自己配得上"龙骑士"的称号，守护世界的和平。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20dragon%20knight%20with%20armor%20standing%20next%20to%20a%20massive%20red%20dragon%2C%20epic%20fantasy%20scene%2C%20dramatic%20sky%20with%20clouds%2C%20warm%20golden%20light%2C%20clean%20anime%20art%20style&width=600&height=850&seq=sakura-anime-cover-007&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20anime%20fantasy%20landscape%20with%20a%20dragon%20soaring%20through%20golden%20clouds%20at%20sunset%2C%20ancient%20castle%20on%20a%20mountain%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20crimson%20tones%2C%20cinematic%20anime%20style%2C%20epic%20scale&width=1600&height=600&seq=sakura-anime-banner-007&orientation=landscape',
    rating: 9.4,
    episodes: 36,
    status: '连载中',
    year: 2025,
    studio: '龙魂工作室',
    director: '马天宇',
    tags: ['战斗', '奇幻', '冒险', '龙'],
    views: 1580000,
    updateDate: '2026-07-30',
    featured: true,
  },
  {
    id: 'anime-008',
    title: '夏日旋律',
    subtitle: 'Summer Melody',
    category: '恋爱日常',
    categorySlug: 'romance',
    description: '音乐社团的夏天，用旋律谱写青春最动人的乐章。',
    longDescription: '热爱音乐的少女苏音加入了学校的轻音社，在这里她遇到了性格迥异但同样热爱音乐的伙伴们。为了参加全国高中生音乐大赛，她们在夏日的阳光下刻苦练习，经历了争吵、和解、成长与感动。当舞台的灯光亮起，当第一个音符响起，所有的汗水都化作了最动人的旋律。这是一个关于音乐、友情和青春的夏天。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20girl%20playing%20guitar%20in%20a%20sunlit%20music%20room%2C%20summer%20atmosphere%2C%20warm%20light%20streaming%20through%20windows%2C%20youthful%20and%20fresh%20style%2C%20clean%20anime%20art%2C%20musical%20theme&width=600&height=850&seq=sakura-anime-cover-008&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Anime%20summer%20scene%20of%20a%20school%20rooftop%20with%20musical%20instruments%2C%20bright%20blue%20sky%20with%20white%20clouds%2C%20warm%20sunlight%2C%20youthful%20energy%2C%20fresh%20and%20vibrant%20colors%2C%20cinematic%20anime%20composition&width=1600&height=600&seq=sakura-anime-banner-008&orientation=landscape',
    rating: 8.7,
    episodes: 13,
    status: '已完结',
    year: 2024,
    studio: '音羽动画',
    director: '周美玲',
    tags: ['音乐', '校园', '青春', '治愈'],
    views: 560000,
    updateDate: '2025-09-10',
    featured: false,
  },
  {
    id: 'anime-009',
    title: '魔女咖啡厅',
    subtitle: 'Witch Cafe',
    category: '搞笑喜剧',
    categorySlug: 'comedy',
    description: '魔女开的咖啡厅里，每一杯饮料都藏着不可思议的魔法。',
    longDescription: '在城市的某个角落，有一家名为"月光猫"的咖啡厅。店主是一位自称退休的魔女，她泡的每一杯咖啡都带有独特的魔法效果——喝了会让人忍不住唱歌的拿铁，喝下后能听懂猫说话的摩卡，还有让人短暂变成透明人的冰美式。每个来到咖啡厅的客人，都有一段需要被治愈的故事，而魔女的魔法咖啡，总能以最意想不到的方式温暖人心。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20cute%20witch%20girl%20serving%20coffee%20in%20a%20cozy%20magical%20cafe%2C%20warm%20interior%20lighting%2C%20whimsical%20decorations%2C%20comforting%20atmosphere%2C%20clean%20anime%20art%20style&width=600&height=850&seq=sakura-anime-cover-009&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Cozy%20anime%20cafe%20interior%20with%20warm%20lighting%2C%20magical%20floating%20sparkles%2C%20wooden%20furniture%2C%20plants%20and%20bookshelves%2C%20comforting%20atmosphere%2C%20soft%20warm%20colors%2C%20wide%20cinematic%20shot&width=1600&height=600&seq=sakura-anime-banner-009&orientation=landscape',
    rating: 8.5,
    episodes: 12,
    status: '已完结',
    year: 2024,
    studio: '月光动画',
    director: '黄小喵',
    tags: ['搞笑', '治愈', '日常', '魔法'],
    views: 480000,
    updateDate: '2025-05-20',
    featured: false,
  },
  {
    id: 'anime-010',
    title: '深渊之门',
    subtitle: 'Abyss Gate',
    category: '悬疑推理',
    categorySlug: 'mystery',
    description: '一扇神秘的古门联通两个世界，探索者们的命运交织。',
    longDescription: '考古学家在发掘一座千年古墓时，意外打开了一扇通往未知世界的门——"深渊之门"。这扇门背后隐藏着一个与人类历史平行的神秘文明。一队由考古学家、军人、语言学家组成的探险队被派往门的另一边进行调查。然而，他们很快发现，门的那一边并非无人之境，而这个古老文明的秘密，远比他们想象的更加危险和复杂。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20mysterious%20ancient%20gate%20with%20strange%20runes%20glowing%2C%20explorers%20standing%20before%20it%2C%20atmospheric%20lighting%20with%20teal%20and%20amber%20glow%2C%20mysterious%20tone%2C%20clean%20anime%20art%20style&width=600&height=850&seq=sakura-anime-cover-010&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20landscape%20with%20an%20ancient%20stone%20gate%20in%20a%20vast%20underground%20cavern%2C%20glowing%20teal%20runes%2C%20atmospheric%20fog%2C%20epic%20scale%2C%20mysterious%20vibe%2C%20cinematic%20anime%20style&width=1600&height=600&seq=sakura-anime-banner-010&orientation=landscape',
    rating: 9.0,
    episodes: 12,
    status: '连载中',
    year: 2026,
    studio: '深渊映像',
    director: '孙浩然',
    tags: ['悬疑', '冒险', '科幻', '考古'],
    views: 720000,
    updateDate: '2026-07-25',
    featured: false,
  },
  {
    id: 'anime-011',
    title: '狐妖小红娘',
    subtitle: 'Fox Spirit Matchmaker',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    description: '千年狐妖为有情人牵线续缘，谱写一段段动人的仙恋故事。',
    longDescription: '在人妖共存的世界里，狐妖涂山红红经营着一家"姻缘铺"，帮助人和妖之间相爱却因寿命差距无法相守的恋人们续写情缘。每一段姻缘都跨越了时间的长河，有些等了一百年，有些等了五百年，有些甚至跨越千年。在帮助他人的过程中，涂山红红也逐渐揭开了自己前世今生的秘密，一段跨越三千年的爱恋正等待着她。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20beautiful%20fox%20spirit%20girl%20with%20ears%20and%20tail%20in%20traditional%20Chinese%20style%20dress%2C%20ancient%20Chinese%20setting%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20elegant%20atmosphere&width=600&height=850&seq=sakura-anime-cover-011&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20ancient%20Chinese%20landscape%20with%20blooming%20peach%20trees%2C%20traditional%20architecture%2C%20misty%20mountains%2C%20warm%20sunrise%20lighting%2C%20romantic%20and%20elegant%20atmosphere%2C%20cinematic%20composition&width=1600&height=600&seq=sakura-anime-banner-011&orientation=landscape',
    rating: 9.6,
    episodes: 48,
    status: '连载中',
    year: 2025,
    studio: '涂山动画',
    director: '杨小狐',
    tags: ['奇幻', '仙侠', '恋爱', '古风'],
    views: 2100000,
    updateDate: '2026-08-03',
    featured: true,
  },
  {
    id: 'anime-012',
    title: '极速传说',
    subtitle: 'Speed Legend',
    category: '热血战斗',
    categorySlug: 'action',
    description: '赛车场上的青春热血，速度与激情的极致碰撞。',
    longDescription: '天才赛车少年林枫因为一次意外失去了参加正式比赛的机会，但他从未放弃对速度的追求。在街头赛车的世界里，他遇到了同样热爱速度的伙伴们和强大的对手。从街头到赛道，从业余到职业，林枫用他的天赋和汗水证明了自己的实力。这不仅是一场关于速度的竞赛，更是一段关于梦想与坚持的热血传奇。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20racer%20leaning%20against%20a%20sleek%20sports%20car%20at%20sunset%2C%20dynamic%20pose%2C%20warm%20golden%20hour%20lighting%2C%20racing%20theme%2C%20clean%20anime%20art%20style&width=600&height=850&seq=sakura-anime-cover-012&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20racing%20scene%20on%20a%20mountain%20road%20at%20sunset%2C%20motion%20blur%20effect%2C%20dramatic%20golden%20lighting%2C%20speed%20and%20excitement%2C%20cinematic%20anime%20style%2C%20wide%20action%20shot&width=1600&height=600&seq=sakura-anime-banner-012&orientation=landscape',
    rating: 8.9,
    episodes: 24,
    status: '已完结',
    year: 2024,
    studio: '极速动画',
    director: '陈飞驰',
    tags: ['赛车', '热血', '青春', '竞技'],
    views: 850000,
    updateDate: '2025-02-28',
    featured: false,
  },
];

export const featuredAnime = animeList.filter(a => a.featured);
export const latestAnime = [...animeList].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime());
export const popularAnime = [...animeList].sort((a, b) => b.views - a.views);

export const testimonials = [
  {
    id: 1,
    name: '动漫达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20man%20with%20black%20hair%2C%20friendly%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration&width=100&height=100&seq=sakura-avatar-001&orientation=squarish',
    content: '樱花动漫是我用过最好的动漫网站！画质清晰，更新速度快，而且完全免费。界面设计也很漂亮，找番超方便。每天必刷！',
    rating: 5,
    date: '2026-07-15',
  },
  {
    id: 2,
    name: '二次元少女小雪',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20cute%20girl%20with%20long%20hair%2C%20gentle%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration&width=100&height=100&seq=sakura-avatar-002&orientation=squarish',
    content: '自从发现了樱花动漫，就再也没换过网站了。分类很详细，推荐也很准，每次都能找到自己想看的新番。强烈推荐给所有动漫爱好者！',
    rating: 5,
    date: '2026-06-28',
  },
  {
    id: 3,
    name: '追番狂人老张',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20adult%20with%20glasses%2C%20friendly%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration&width=100&height=100&seq=sakura-avatar-003&orientation=squarish',
    content: '追了十年动漫，用过无数网站，樱花动漫的综合体验绝对排第一。播放流畅不卡，字幕质量高，还支持多设备同步观看记录。满分好评！',
    rating: 5,
    date: '2026-07-05',
  },
  {
    id: 4,
    name: '萌新小可爱',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20girl%20with%20twin%20tails%2C%20happy%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration&width=100&height=100&seq=sakura-avatar-004&orientation=squarish',
    content: '刚入坑动漫不久，朋友推荐了樱花动漫。网站用起来真的很简单，分类很清楚，还有详细的介绍帮助我选择。现在每天都要看几集，完全停不下来！',
    rating: 4,
    date: '2026-07-20',
  },
];